import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "App-Reset-Succ",
  "txt-center": ""
}
const _hoisted_2 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        lazy: "",
        "m-t-1q": "",
        style: `width: 230px;`,
        src: _ctx.img
      }, null, 8, ["src"])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("h2", {
      "f-w-600": "",
      "m-tb-0": "",
      "txt-center": ""
    }, " Hmm... this email verification link isn't valid ", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", {
      "txt-center": "",
      "m-tb-0": ""
    }, " Try and log back in to request a new one. ", -1))
  ]))
}